import { config } from '@static/js/env.config';
import { getDeviceResolution } from './deviceResolution';
import { getNodeEnv } from './getEnvironmentVariables';
const { isDevelopment } = getNodeEnv();

const PUBLIC_ASSETS_FOLDER = `https://withjoy.com/assets/public`;

// CDN base for self-hosted Google Fonts mirrored to S3. Published by scripts/font-mirror/.
export const SELF_HOSTED_FONTS_BASE = `${PUBLIC_ASSETS_FOLDER}/fonts/google`;

const assetScale = {
  1: '',
  2: '@2x',
  3: '@3x',
} as const;

const DEVICE_RESOLUTION = getDeviceResolution() as keyof typeof assetScale;

const ASSET_SCALE: string = assetScale[DEVICE_RESOLUTION] || assetScale[1];
export const TIMESTAMP_PARAM = new Date().toISOString().split('T')[0];

export const URLS = {
  graphicAccent: (accentId: string, scale?: 1 | 2 | 3) => {
    let affix: string = ASSET_SCALE;
    if (scale) {
      affix = assetScale[scale];
    }
    return `${PUBLIC_ASSETS_FOLDER}/graphicAccents/accent_${accentId}${affix}.png`;
  },
  styleApplicatorLib: `${isDevelopment ? config.clientUri + '/assets' : PUBLIC_ASSETS_FOLDER}/styles/applicator.js?ts=${TIMESTAMP_PARAM}`,
  webfontLib: 'https://ajax.googleapis.com/ajax/libs/webfont/1.6.26/webfont.js',
  walletButton: (platform: 'apple' | 'google', lang: string) => `${PUBLIC_ASSETS_FOLDER}/wallet-buttons/${platform}/${lang}.svg`,
} as const;

export const DOMAIN_NAME = 'withjoy.com/';
